"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowanceOperation = exports.SignerKeyRingType = exports.InstructionAffirmationOperation = exports.ClaimOperation = exports.TransferRestrictionType = exports.TxGroup = exports.RoleType = void 0;
// Roles
var RoleType;
(function (RoleType) {
    RoleType["TickerOwner"] = "TickerOwner";
    RoleType["CddProvider"] = "CddProvider";
    RoleType["VenueOwner"] = "VenueOwner";
    RoleType["PortfolioCustodian"] = "PortfolioCustodian";
    RoleType["CorporateActionsAgent"] = "CorporateActionsAgent";
    // eslint-disable-next-line @typescript-eslint/no-shadow
    RoleType["Identity"] = "Identity";
})(RoleType = exports.RoleType || (exports.RoleType = {}));
/**
 * Transaction Groups (for permissions purposes)
 */
var TxGroup;
(function (TxGroup) {
    /**
     * - TxTags.identity.AddInvestorUniquenessClaim
     * - TxTags.portfolio.MovePortfolioFunds
     * - TxTags.settlement.AddInstruction
     * - TxTags.settlement.AddInstructionWithMemo
     * - TxTags.settlement.AddAndAffirmInstruction
     * - TxTags.settlement.AddAndAffirmInstructionWithMemo
     * - TxTags.settlement.AffirmInstruction
     * - TxTags.settlement.RejectInstruction
     * - TxTags.settlement.CreateVenue
     */
    TxGroup["PortfolioManagement"] = "PortfolioManagement";
    /**
     * - TxTags.asset.MakeDivisible
     * - TxTags.asset.RenameAsset
     * - TxTags.asset.SetFundingRound
     * - TxTags.asset.AddDocuments
     * - TxTags.asset.RemoveDocuments
     */
    TxGroup["AssetManagement"] = "AssetManagement";
    /**
     * - TxTags.asset.Freeze
     * - TxTags.asset.Unfreeze
     * - TxTags.identity.AddAuthorization
     * - TxTags.identity.RemoveAuthorization
     */
    TxGroup["AdvancedAssetManagement"] = "AdvancedAssetManagement";
    /**
     * - TxTags.identity.AddInvestorUniquenessClaim
     * - TxTags.settlement.CreateVenue
     * - TxTags.settlement.AddInstruction
     * - TxTags.settlement.AddInstructionWithMemo
     * - TxTags.settlement.AddAndAffirmInstruction
     * - TxTags.settlement.AddAndAffirmInstructionWithMemo
     */
    TxGroup["Distribution"] = "Distribution";
    /**
     * - TxTags.asset.Issue
     */
    TxGroup["Issuance"] = "Issuance";
    /**
     * - TxTags.complianceManager.AddDefaultTrustedClaimIssuer
     * - TxTags.complianceManager.RemoveDefaultTrustedClaimIssuer
     */
    TxGroup["TrustedClaimIssuersManagement"] = "TrustedClaimIssuersManagement";
    /**
     * - TxTags.identity.AddClaim
     * - TxTags.identity.RevokeClaim
     */
    TxGroup["ClaimsManagement"] = "ClaimsManagement";
    /**
     * - TxTags.complianceManager.AddComplianceRequirement
     * - TxTags.complianceManager.RemoveComplianceRequirement
     * - TxTags.complianceManager.PauseAssetCompliance
     * - TxTags.complianceManager.ResumeAssetCompliance
     * - TxTags.complianceManager.ResetAssetCompliance
     */
    TxGroup["ComplianceRequirementsManagement"] = "ComplianceRequirementsManagement";
    /**
     * - TxTags.checkpoint.CreateSchedule,
     * - TxTags.checkpoint.RemoveSchedule,
     * - TxTags.checkpoint.CreateCheckpoint,
     * - TxTags.corporateAction.InitiateCorporateAction,
     * - TxTags.capitalDistribution.Distribute,
     * - TxTags.capitalDistribution.Claim,
     * - TxTags.identity.AddInvestorUniquenessClaim,
     */
    TxGroup["CorporateActionsManagement"] = "CorporateActionsManagement";
    /**
     * - TxTags.sto.CreateFundraiser,
     * - TxTags.sto.FreezeFundraiser,
     * - TxTags.sto.Invest,
     * - TxTags.sto.ModifyFundraiserWindow,
     * - TxTags.sto.Stop,
     * - TxTags.sto.UnfreezeFundraiser,
     * - TxTags.identity.AddInvestorUniquenessClaim,
     * - TxTags.asset.Issue,
     * - TxTags.settlement.CreateVenue
     */
    TxGroup["StoManagement"] = "StoManagement";
})(TxGroup = exports.TxGroup || (exports.TxGroup = {}));
var TransferRestrictionType;
(function (TransferRestrictionType) {
    TransferRestrictionType["Count"] = "Count";
    TransferRestrictionType["Percentage"] = "Percentage";
    TransferRestrictionType["ClaimCount"] = "ClaimCount";
    TransferRestrictionType["ClaimPercentage"] = "ClaimPercentage";
})(TransferRestrictionType = exports.TransferRestrictionType || (exports.TransferRestrictionType = {}));
var ClaimOperation;
(function (ClaimOperation) {
    ClaimOperation["Revoke"] = "Revoke";
    ClaimOperation["Add"] = "Add";
    ClaimOperation["Edit"] = "Edit";
})(ClaimOperation = exports.ClaimOperation || (exports.ClaimOperation = {}));
var InstructionAffirmationOperation;
(function (InstructionAffirmationOperation) {
    InstructionAffirmationOperation["Affirm"] = "Affirm";
    InstructionAffirmationOperation["Withdraw"] = "Withdraw";
    InstructionAffirmationOperation["Reject"] = "Reject";
    InstructionAffirmationOperation["AffirmAsMediator"] = "AffirmAsMediator";
    InstructionAffirmationOperation["WithdrawAsMediator"] = "WithdrawAsMediator";
    InstructionAffirmationOperation["RejectAsMediator"] = "RejectAsMediator";
})(InstructionAffirmationOperation = exports.InstructionAffirmationOperation || (exports.InstructionAffirmationOperation = {}));
var SignerKeyRingType;
(function (SignerKeyRingType) {
    SignerKeyRingType["Ed25519"] = "Ed25519";
    SignerKeyRingType["Sr25519"] = "Sr25519";
    SignerKeyRingType["Ecdsa"] = "Ecdsa";
})(SignerKeyRingType = exports.SignerKeyRingType || (exports.SignerKeyRingType = {}));
var AllowanceOperation;
(function (AllowanceOperation) {
    AllowanceOperation["Set"] = "Set";
    AllowanceOperation["Increase"] = "Increase";
    AllowanceOperation["Decrease"] = "Decrease";
})(AllowanceOperation = exports.AllowanceOperation || (exports.AllowanceOperation = {}));
//# sourceMappingURL=types.js.map